<template>
  <div class="px-0 pb-0 card-body">
    <!-- Loading Spinner -->
    <div v-if="loading && filteredData.length === 0" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2">Loading VSOL GPON ONU data...</p>
    </div>

    <!-- Data Table -->
    <div class="table-responsive" v-else-if="filteredData.length > 0">
      <div class="card mb-4">
        <div class="card-body px-0 pt-0 pb-2 invoice">
          <div class="table-responsive p-0">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Interface</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">ONU ID</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Description</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Admin State</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Alive Time</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Last Dereg Time</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(onu, index) in filteredData" :key="index">
                  <td class="align-middle text-center text-sm">{{ getInterface(onu.onu_id) }}</td>
                  <td class="align-middle text-center text-sm">{{ onu.onu_id }}</td>
                  <td class="align-middle text-center text-sm">{{ onu.description }}</td>
                  <td class="align-middle text-center text-sm">{{ onu.admin_state }}</td>
                  <td class="align-middle text-center text-sm">{{ onu.alive_time }}</td>
                  <td class="align-middle text-center text-sm">{{ onu.last_deregister_time }}</td>
                  <td class="text-center">
                    <soft-badge
                      class="p-1 rounded-1 cursor-pointer text-sm"
                      :class="getStatusClass(onu.phase_state)"
                      variant="gradient"
                      size="sm"
                    >
                      {{ formatStatus(onu.phase_state) }}
                    </soft-badge>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Skeleton if no data -->
    <div v-else>
      <Skalaton />
    </div>
  </div>
</template>

<script>
import Skalaton from "@/components/Skalaton.vue";

export default {
  name: "VsolGponTable",
  components: {
    Skalaton,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    filteredData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getInterface(onuId) {
      return onuId ? onuId.split(":")[0] : "N/A";
    },
    formatStatus(status) {
      if (!status) return "Unknown";
      return status.charAt(0).toUpperCase() + status.slice(1);
    },
    getStatusClass(status) {
      const s = status ? status.toLowerCase() : "";
      return {
        "bg-danger bg-opacity-25": s === "los" || s === "offline",
        "bg-success bg-opacity-25": s === "online",
        "bg-warning bg-opacity-50": s === "unknown",
      };
    },
  },
};
</script>

<style scoped>
td {
  padding: 12px 24px !important;
}
.table-responsive {
  overflow-x: auto;
}
.text-sm {
  font-size: 0.875rem !important;
}
.text-xxs {
  font-size: 0.75rem !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
